const sv = {
  APPLICATION_TYPE: {
    newLoanApplication: 'Lån för köp av bostad',
    transferLoanApplication: 'Övertag av lån / Lån på obelånad bostad',
    commitmentApplication: 'Lånelöfte',
    topupLoanApplication: 'Höjning av befintligt lån',
  },
  APPLICATION_STATUS: {
    draft: 'Utkast',
    approved: 'Godkänd',
    rejected: 'Nekad',
    submitted: 'Inskickad',
    working: 'Handläggning pågår',
    complete: 'Klar för underskrift',
    signed: 'Signerad',
    active: 'Utbetald',
    cancel: 'Makulerad',
    repaid: 'Återbetald',
  },
  PARTY_STATUS: {
    owner: 'Ägare (eller planerad ägare) av bostaden',
    ownerNotApplicant: 'Ägare (eller planerad ägare) av bostaden men inte låntagare',
    married: 'Ej ägare av bostaden: Make/maka till en låntagare',
    domesticPartner: 'Ej ägare av bostaden: Sambo till en låntagare',
    applicantNotOwner: 'Inget av ovanstående: Låntagare som inte är ägare av bostaden',
  },
  PROPERTY_TYPE: {
    apartment: 'Bostadsrätt',
    house: 'Villa',
    vacation: 'Fritidshus',
    rental: 'Hyresrätt',
  },
  INCOME_SOURCE: {
    stated: 'Uppgiven',
    uc: 'UC',
    complement: 'Komplettering',
  },
  INCOME_TYPE: {
    employment: 'Tjänsteinkomst',
    capital: 'Kapitalinkomst',
  },
  PAYOUT_TYPE: {
    amortization: 'Direktamortering',
    expense: 'Utlägg vi gör åt kunden',
    fee: 'Betalning till Hypoteket för tjänster (t.ex. pantbrev)',
    repayMortgage: 'Lösen av bolån/ränta/RSE',
    repayUnsecured: 'Lösen av blancolån',
    cashDisbursement: 'Kontantutbetalning',
    saveAvailable: 'Spara tillgängligt',
    useAvailable: 'Använd tillgängligt',
    amortizationBridgeLoan: 'Amortering brygglån',
  },
  PAYOUT_SOURCE: {
    disbursement: 'Disb. A.',
    clientAccount: 'KMK',
    unsecuredDisbursementAccount: 'Disb. A. Brygg/HP',
  },
  INTEREST_TERM: {
    threeMonth: '3 mån',
    sixMonth: '6 mån',
    oneYear: '1 år',
    twoYear: '2 år',
    threeYear: '3 år',
    fourYear: '4 år',
    fiveYear: '5 år',
    sevenYear: '7 år',
    tenYear: '10 år',
  },
  PURPOSE: {
    renovation: 'Renovera min bostad',
    buyCar: 'Köpa en ny bil',
    helpRelative: 'Hjälpa en familjemedlem med kontantinsats vid bostadsköp',
    other: 'Annan anledning',
    heatPump: 'Installation av ny värmepump',
    ventilationHeatRecovery: 'Installation av från- och tilluftsventilation med värmeåtervinning',
    mechExhaustVentilation: 'Installation av mekanisk frånluftsventilation',
    pelletBoiler: 'Installation av pelletspanna',
    solarCells: 'Installation av solceller',
    solarHeating: 'Installation av solvärme',
    districtHeatingSubCentral: 'Installation av undercentral för fjärrvärme',
    woodBoiler: 'Installation av vedpanna',
    combinedHeatVentilation: 'Kombinerade värme- och ventilationssystem',
    windowReplacement: 'Byte av fönster',
    roofInsulation: 'Isolering av yttertak',
    facadeOrAtticInsulation: 'Tilläggsisolering av fasad eller vind',
  },
  DEBT_STATUS: {
    active: 'Aktiv',
    repaid: 'Återbetald',
  },
  LOAN_TYPE: {
    mortgage: 'Bolån',
    'bridge-loan': 'Brygglån',
  },
}

export default sv
